import type { ThemeConfig } from 'antd';
import { theme as antdTheme } from 'antd';

/**
 * Тема для antd-компонентов клиентского модуля. antd рисует через свои токены
 * (CSS-in-JS) и НЕ видит наши CSS-переменные --clr-*, поэтому акценты дублируем
 * здесь значениями, синхронными с styles/theme.scss.
 *
 *  - обычный веб  → веб-палитра (красный бренд), светлый алгоритм;
 *  - WebView      → нативная палитра (оранжевый бренд, текст на нём тёмный); тёмная
 *                   тема включает darkAlgorithm (в браузере тема всегда светлая).
 *                   В тёмной теме бренд приглушён, а статусы светлее — как и в CSS.
 *
 * Применяется через вложенный ConfigProvider в ClientLayout (локаль и прочее
 * наследуются от глобального ConfigProvider в index.tsx).
 */
const WEB_PALETTE = {
  colorPrimary: '#ff2e1f',
  colorError: '#e03137',
  colorSuccess: '#0caf60',
  colorWarning: '#f59e0b',
  colorInfo: '#1677ff'
};

const NATIVE_PALETTE = {
  light: {
    colorPrimary: '#ff7726',
    colorLink: '#b24d0e',
    colorError: '#e5484d',
    colorSuccess: '#17715a',
    colorWarning: '#e5a83a',
    colorInfo: '#176fbd',
    colorText: '#10192a'
  },
  dark: {
    colorPrimary: '#f27b36',
    colorLink: '#f27b36',
    colorError: '#e5484d',
    colorSuccess: '#3fb58a',
    colorWarning: '#e5a83a',
    colorInfo: '#4aa3ef',
    colorText: '#f1f1f0'
  }
};

export const getClientAntdTheme = (
  mode: 'light' | 'dark',
  isNative: boolean
): ThemeConfig => {
  const darkTheme = mode === 'dark';
  return {
    algorithm:
      isNative && darkTheme
        ? antdTheme.darkAlgorithm
        : antdTheme.defaultAlgorithm,
    token: {
      ...(isNative
        ? NATIVE_PALETTE[mode]
        : { ...WEB_PALETTE, colorText: '#111827' }),
      borderRadius: 10
    },
    components: {
      // В нативке текст на оранжевом colorPrimary — тёмный (danger-кнопки не трогает).
      ...(isNative && { Button: { primaryColor: '#10192a' } }),
      Steps: {
        colorPrimary: '#1677ff',
        colorPrimaryBg: 'rgba(43, 143, 229, 0.12)'
      }
    }
  };
};
